import React, { useState } from "react";
import { Div, Text, Image, Anchor } from "atomize";
import CustomContainer from "../common/CustomContainer";
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import VideoModal from "../common/VideoModal";

export default function CustomizationSection() {
  const { scroll } = useLocomotiveScroll();
  const [showVideo, setShowVideo] = useState(false)

  scroll?.on("scroll", (instance) => {
    if (Object.keys(instance.currentElements).includes('el20')) {
      const element = instance.currentElements.el20;
      element.el.style.transform = `rotate(${-30 + (((instance.scroll.y - element.top + window.innerHeight) / window.innerHeight) * 10)}deg)`;
    }
  });


  return (
    <>
      <Div tag="section" data-scroll-section pos="relative" zIndex="1" overflow="visible" p="7rem 0 6rem" border={{ y: "1px solid" }} borderColor="light">
        <CustomContainer overflow="visible">
          <Div pos="relative" overflow="visible" maxW="79rem" m="0 auto">
            <Div overflow="visible" pos={{ xs: "relative", md: "absolute" }} left="0" top={{ md: "3rem" }}>
              <Image data-scroll data-scroll-speed="1" src="/images/icons/spark.svg" alt="spark-icon-image" w={{ xs: "72px", lg: "96px", xl: "112px" }} pos="absolute" top={{ xs: "-2.5rem", lg: "-3rem" }} left="0" />
              <Div data-scroll data-scroll-speed="1" overflow="visible">
                <Div
                  tag="h2"
                  data-scroll
                  bg="black"
                  border="1px solid"
                  borderColor="outline"
                  textSize={{ xs: "paragraph", lg: "subtitle", xl: "subheader" }}
                  h={{ xs: "104px", lg: "140px", xl: "168px" }}
                  w={{ xs: "280px", lg: "340px", xl: "440px" }}
                  d="flex"
                  align="center"
                  justify="center"
                  rounded="50%"
                  textWeight="300"
                  transform={{ xs: "rotate(-20deg)", md: "rotate(-30deg)" }}
                  textTransform="uppercase"
                  m={{ xs: "0 0 3rem", sm: "0 0 2.5rem", md: '0' }}
                >
                  Customizations ☻
              </Div>
              </Div>
            </Div>
            <Div d="flex" justify="flex-end">
              <Div w="100%" maxW={{ md: "50%", lg: "56%", xl: "44rem" }}>
                <Text textWeight="300" textSize={{ xs: "subtitle", md: "subheader", lg: "header" }} m={{ b: { xs: "1.5rem", lg: "2rem" } }}>
                  Apply gradients, surface textures, or bring out the bling with
                  metallic customization.
                </Text>
                <Anchor className="trans-opacity" onClick={() => setShowVideo(true)} textWeight="700" style={{ lineHeight: '20px' }} textColor="white" hoverTextColor="white" textDecor="none" cursor="pointer" border={{ b: '2px solid' }} borderColor="white">
                  Watch video 🎬
                </Anchor>
              </Div>
            </Div>
            <Div overflow="hidden">
              <Div
                d="flex"
                justify="center"
                flexWrap="wrap"
                m={{ xs: "3rem -1.5rem 0", sm: "3rem -2rem 0", md: "4.25rem -1rem 0", xl: "5.75rem -2rem 0" }}
              >
                {customTexturesArray.map((texture, index) => (
                  <Div
                    key={`${texture.style}-${index}`}
                    m={{ b: '1.5rem' }}
                    flexGrow={{ xs: "50%", sm: "1 0 33.33%", md: "1 0 20%" }}
                    maxW={{ xs: "50%", sm: "33.33%", md: "20%" }}
                    p={{ xs: "0 1.5rem", sm: "0 2rem", md: "0 1rem", xl: "0 2rem" }}
                  >
                    <Image src={texture.image} alt={texture.altText} />
                    <Text
                      textSize={{ xs: "caption", lg: "body" }}
                      textAlign="center"
                      textColor="dark"
                      m={{ t: { xs: "0.75rem", lg: "2rem" } }}
                    >
                      {texture.name}
                    </Text>
                  </Div>
                ))}
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </Div>
      <VideoModal isOpen={showVideo} close={() => setShowVideo(false)} />
    </>
  );
}

const customTexturesArray = [{
  image: "/images/texture-icons/disk1.png",
  name: "Gradient",
  altText: "Gradient color surface",
}, {
  image: "/images/texture-icons/disk2.png",
  name: "Solid Black",
  altText: "Solid colors surface",
}, {
  image: "/images/texture-icons/disk3.png",
  name: "Surface Texture",
  altText: "Surface texture surface",
}, {
  image: "/images/texture-icons/disk4.png",
  name: "Metallic",
  altText: "Metallic texture surface",
}, {
  image: "/images/texture-icons/disk5.png",
  name: "Colored Metallic",
  altText: "Metallic color texture surface",
}];